import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '@app/stp/state/reducers';

const selectStpStore = createFeatureSelector<State>('stpStore');

const selectJourneyNavigationState = createSelector(
  selectStpStore,
  (state: State) => state.journeyNavigationState
);

const selectJourneyNavigationDetails = createSelector(
  selectJourneyNavigationState,
  (state) => state.nextJourneyDetails
);

export const selectNavigationDetails = createSelector(
  selectJourneyNavigationDetails,
  (state) => state.navConfig
);

export const selectPanelConfig = createSelector(
  selectJourneyNavigationDetails,
  (state) => state.panelConfig
);

export const selectNavDirection = createSelector(
  selectJourneyNavigationState,
  (state) => state.navDirection
);

export const selectJourneyPath = createSelector(
  selectJourneyNavigationState,
  (state) => state.journeyPath
);
